// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

export const verifySlugApi = async (value) => {
  return DataService.get(`verify-slug?slug=${value}`);
};
export const createPaymentApi = async (value) => {
  return DataService.post(`create-payment`, value);
};
export const paymentVerifyApi = async (value) => {
  return DataService.get(`verify-payment?id=${value}`);
};
export const completeStripeOnboardingApi = async () => {
  return DataService.get(`user/stripe-onboard`);
};
export const verifyStripeOnboardingApi = async () => {
  return DataService.get(`user/verify-stripe-onboard`);
};
export const getPaymentHistoryApi = async (data) => {
  return DataService.get(`payment-history?search=${data?.search}`);
};
export const getNextPagePaymentHistoryApi = async (data) => {
  return DataService.get(`payment-history?${getQueryString(data)}`);
};
export const getKPIDataApi = async () => {
  return DataService.get(`kpi`);
};

export const getPlatformCommissionKpiApi = async () => {
  return DataService.get(`/kpis?${getQueryString({ model: 'platform_commission' })}`);
};
